import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
var Wrapper = styled.div.withConfig({
  componentId: "sc-yyjwi5-0"
})(function (_ref) {
  var $columns = _ref.$columns,
    theme = _ref.theme;
  return css(["display:grid;", "{border-radius:", ";box-shadow:", ";> *{padding:", ";border-bottom:", " solid ", ";&:first-child{border-radius:", ";border-bottom-right-radius:0;border-bottom-left-radius:0;}&:last-child{border-radius:", ";border-top-left-radius:0;border-top-right-radius:0;border-bottom-color:transparent;}}}", "{grid-gap:", ";grid-template-columns:repeat(", ",1fr);> *{", ";&:hover{transform:translateY(-3rem);}border-bottom:0;}}", "{grid-gap:", ";}"], breakpoint("small", "large"), getBorderRadius(theme, "large"), getBoxShadow(theme, "medium"), space(3), unit(1), getBorderColor(theme, "backgroundLight", "low"), getBorderRadius(theme, "large"), getBorderRadius(theme, "large"), breakpoint("large"), space(2), $columns, transition("transform"), breakpoint("huge"), space(3));
});
var TilesLinkOrg = function TilesLinkOrg(_ref2) {
  var children = _ref2.children,
    columns = _ref2.columns,
    id = _ref2.id;
  return /*#__PURE__*/React.createElement(Wrapper, {
    $columns: columns,
    id: id
  }, children);
};
export default TilesLinkOrg;